"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardPicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CardArt = require("../../base-components/CardArt/variants/us-consumer/CardArt");
var _Icon = require("../../base-components/Icon/Icon");
var _ClickableElement = require("../../base-components/Button/ClickableElement");
var _PropertyProvider = require("../../utils/PropertyProvider/PropertyProvider");
var _svgFetcher = _interopRequireDefault(require("../../utils/svgFetcher"));
var _Sanitizer = require("../../base-components/Sanitizer/Sanitizer");
var _getCardImage = _interopRequireDefault(require("../../utils/getCardImage"));
var _textUtilities = require("../../utils/text-utilities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// UI COMPONENTS

// UTILITIES

var DLSCOREBLUE = '#006fcf';
var CardPicker = exports.CardPicker = function CardPicker(_ref) {
  var cards = _ref.cards,
    styles = _ref.styles,
    onExit = _ref.onExit,
    onPick = _ref.onPick,
    selected = _ref.selected,
    namespace = _ref.namespace,
    dtm = _ref.dtm,
    CancelIcon = _ref.CancelIcon,
    headerText = _ref.headerText,
    HeaderComponent = _ref.HeaderComponent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('card-picker', styles.modal)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.modalContent
  }, /*#__PURE__*/_react["default"].createElement(HeaderComponent, null, headerText), /*#__PURE__*/_react["default"].createElement(_ClickableElement.ClickableElement, {
    dtm: dtm,
    Component: "span",
    onClick: onExit,
    namespace: (0, _PropertyProvider.NS)(namespace, 'icon-close'),
    namespacesuffix: "exit-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    Svg: CancelIcon,
    styles: {
      icon: styles.cancelIcon
    },
    color: DLSCOREBLUE,
    namespace: namespace
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.cardList
  }, cards.map(function (card, cardIndexPosition) {
    var isSelected = selected.find(function (selection) {
      return selection.shortName === card.shortName;
    }) && styles.selected;
    var cardImage = (0, _getCardImage["default"])(card, 'tile');
    return /*#__PURE__*/_react["default"].createElement(_ClickableElement.ClickableElement, {
      Component: "span",
      model: card,
      key: card.shortName,
      className: (0, _classnames["default"])('card-picker__card', styles.choice, isSelected),
      onClick: function onClick() {
        return onPick(card);
      },
      dtm: card.cardPickerSelectDtm,
      namespace: (0, _PropertyProvider.NS)(namespace, 'card-picker'),
      namespacesuffix: "selected-card-art",
      indexpos: cardIndexPosition
    }, /*#__PURE__*/_react["default"].createElement(_CardArt.CardArt, {
      cardArt: cardImage.url,
      altText: cardImage.alt,
      className: styles.cardArt,
      dtm: card.dtm,
      namespace: namespace
    }), /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
      className: styles.cardTitle,
      safelySetInnerHTML: (0, _textUtilities.stripTags)(card.cardTitle)
    }));
  }))));
};
CardPicker.defaultProps = {
  styles: {},
  selected: [],
  namespace: '',
  dtm: {},
  headerText: 'Select Cards to compare',
  CancelIcon: function CancelIcon() {
    return (0, _svgFetcher["default"])('axp-icon-cancelcircle', 'us-consumer');
  },
  HeaderComponent: 'h3'
};
CardPicker.propTypes = {
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  cards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    assets: _propTypes["default"].arrayOf(_propTypes["default"].object),
    cardTitle: _propTypes["default"].string
  })).isRequired,
  selected: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    assets: _propTypes["default"].arrayOf(_propTypes["default"].object),
    cardTitle: _propTypes["default"].string
  })),
  HeaderComponent: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  onPick: _propTypes["default"].func.isRequired,
  onExit: _propTypes["default"].func.isRequired,
  namespace: _propTypes["default"].string,
  dtm: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].object), _propTypes["default"].objectOf(_propTypes["default"].string)]),
  headerText: _propTypes["default"].string,
  CancelIcon: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
};